// @ts-check
import { useEffect, useState } from 'react';

/**
 * useDebounce — returns a value that lags behind `value` by `delayMs` ms.
 *
 * Typical use: debouncing a search input so we don't fire a request on every
 * keystroke. The debounced value updates only after the user pauses typing.
 *
 * @template T
 * @param {T} value
 * @param {number} [delayMs]
 * @returns {T}
 */
export function useDebounce(value, delayMs = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
